import React, {useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';
import useHttp from 'utils/hooks/useHttp';
import {notify} from 'utils/marketplace';
import {AxiosError} from 'axios';
import Spinner from 'components/spinner/Spinner';
import { IBattery } from 'interfaces/battery';
import BatteryPhotoGallery from './BatteriesPhotoGallery/BatteryPhotoGallery';
import BatteryDetails from './BatteriesDetails/BatteryDetails';
import BatteryOptions from './BatteriesOptions/BatteryOptions';
import './BatteriesView.scss';
import { useTranslation } from 'react-i18next';

const BatteriesView: React.FC = () => {
  const http = useHttp();
  const { id } = useParams<'id'>();
  const {i18n} = useTranslation();

  const [batteries, setBatteries] = useState<IBattery>();
  const [loading, isLoading] = useState(false);


  useEffect(() => {
    getBattery();
  }, [i18n.language]);


  const getBattery = async () => {
    isLoading(true);

    try {

      await http.batteriesHttp.getBattery(String(id)).then(res=> setBatteries(res.data));

      
    } catch (e: unknown) {

      if(e instanceof AxiosError) {
        const message = e?.response?.data?.detail;

        notify(message);
      }


    } finally {
      isLoading(false);
    }
  };

  return (

    <div className="battery-wrapper">
      {
        loading ? (
          <Spinner class="small"/>
        ) : (
          <div>
            {
              batteries && (
                <div>
                  <div className="battery">
                    <div className="gallery">
                      <BatteryPhotoGallery battery={batteries}/>
                    </div>
                    <div className="details">
                      <BatteryDetails battery={batteries}/>
                    </div>
                    <div className="options">
                      <BatteryOptions battery={batteries}/>
                    </div>
                  </div>
                </div>
              )
            }
          </div>
        )
      }
    </div>
  );
};


export default BatteriesView;